// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import SomethingWentWrong from 'shared/components/SomethingWentWrong';
import PageNotFound from 'shared/components/NotFound';

// defs
import { ILandingPageStateProps } from 'shared/layouts/LandingPage/types';

function API({
  children,
  landingPageData,
  isFetchingError,
  isNotFound,
  pageName,
  errorStatusCode,
}: ILandingPageStateProps) {
  if (isEmpty(landingPageData)) {
    if (isNotFound) {
      return <PageNotFound />;
    }

    if (isFetchingError) {
      return <SomethingWentWrong statusCode={errorStatusCode} />;
    }
  }

  return <>{children({ landingPageData, pageName })}</>;
}

export default memo(API);
